import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  public downloadCompleted = false;
  constructor() {}

  yyyymmddhhmmss = function (dateIn) {
    const yyyy = dateIn.getFullYear();
    // getMonth() is zero-based
    const MM = dateIn.getMonth() + 1;
    const dd = dateIn.getDate();
    const hh = dateIn.getHours();
    const mm = dateIn.getMinutes();
    const ss = dateIn.getSeconds();
    // Leading zeros for mm and dd
    return String(10000000000 * yyyy + 100000000 * MM + 1000000 * dd + 10000 * hh + 100 * mm * ss);
  };

  downloadFile(response, filename) {
    let headerFileName = this.getContentDispositionHeader(response.headers.get('Content-Disposition'));
    if (headerFileName === '') {
      headerFileName = filename;
    }
    this.downloadBlobFile(response.body, headerFileName);
  }

  getContentDispositionHeader(contentDisposition): string {
    let headerFileName = '';
    if (contentDisposition) {
      const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = fileNameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        headerFileName = matches[1].replace(/['"]/g, '');
      }
    }
    return headerFileName;
  }

  downloadBlobFile(fileContent, fileName): void {
    const blob = new Blob([fileContent], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    const downloadInterval = setInterval(() => {
      this.downloadCompleted = true;
      clearInterval(downloadInterval);
    }, 1000);
  }
}
